export const SPECIAL_AGENT_IDS = {
  AUDIENCE_FLOW: 'audience-flow-agent',
  AUDIENCE_FLOW_PERSONA_PREFIX: 'audience-flow-persona-',
  DEEP_RESEARCH_OPPORTUNITY_IDENTIFIER: 'deep-research-opportunity-identifier',
  SOCIAL_MEDIA_BRIEF: 'social-media-brief',
  EXTERNAL_TOOLS: 'external-tools-agent',
  // Mirrors the backend `TranslationAgentId` (apps/api/.../translation/index.ts).
  // Apps can't share the constant directly, so keep these two in sync.
  TRANSLATION: 'translation-agent',
  // Mirrors the backend `MonksflowSalesSupportAgentId`
  // (apps/api/.../use-cases/monksflow-support/index.ts). Same deal as TRANSLATION.
  SALES_SUPPORT: 'monksflow-sales-support',
  // An agent built on the canvas. Mirrors the backend's `AGENT_DEFINITION_PREFIX`.
  // eslint-disable-next-line i18next/no-literal-string -- wire id prefix, never rendered
  AGENT_DEFINITION_PREFIX: 'adef_',
} as const;

/** Encode a persona id into its audience-flow agent id slug. The inverse is
 * `getPersonaIdFromAgentId`. */
export const getPersonaAgentId = (personaId: string): string =>
  `${SPECIAL_AGENT_IDS.AUDIENCE_FLOW_PERSONA_PREFIX}${personaId}`;

export const getPersonaIdFromAgentId = (agentId: string | null | undefined): string | null => {
  const prefix = SPECIAL_AGENT_IDS.AUDIENCE_FLOW_PERSONA_PREFIX;
  if (!agentId?.startsWith(prefix)) return null;
  return agentId.slice(prefix.length) || null;
};
